<template>
  <v-btn :type="type" :disabled="disabled" class="btn-save" @click="evOnClick">
    <i class="fas fa-save mr-2 text-twenty"></i>
    {{ loading ? "CARREGANDO" : text }}
  </v-btn>
</template>

<script>
export default {
  name: "VBtnSave",

  props: {
    type: { type: String, default: "button" },
    loading: { type: Boolean, default: false },
    text: { type: String, default: "SALVAR" },
    disabled: { type: Boolean, default: false },
  },

  methods: {
    async evOnClick(event) {
      this.$emit("click", event);
    },
  },
};
</script>

<style>
</style>